module.exports = __webpack_public_path__ + "static/media/Twitter.0c9462a7.svg";